export const ISSUES_FOR_CHALLAN_REQUEST = "ISSUES_FOR_CHALLAN_REQUEST";
export const ISSUES_FOR_CHALLAN_SUCCESS = "ISSUES_FOR_CHALLAN_SUCCESS";
export const ISSUES_FOR_CHALLAN_FAILED = "ISSUES_FOR_CHALLAN_FAILED";